module.exports = __webpack_public_path__ + "b39a756ebed2b0169ab8dd8a18b56370.svg";